export default __webpack_public_path__ + "static/media/30t.57d9237b.jpg";